/**
 * Main object containing all message type constants.
 * Using 'as const' ensures these are treated as literal types rather than strings.
 */
export const MESSAGE_TYPES = {
  TEXT: 'txt',
  GIFT: 'gift',
  SHARE_LOCATION: 'shareLocation',
  SHARE_EVENT: 'shareEvent',
  SHARE_DATE: 'shareDate',
  MEDIA: 'media', // use this one to verify function send shared media, it's not used to handle send message in core
  IMAGE: 'img',
  VIDEO_FILE: 'videoFile',
  AUDIO_FILE: 'audioFile',
  GALLERY: 'gallery',
  CHAT_STATE: 'chatState',
  VIDEO: 'video',
  PRIVATE_MSG: 'private-msg',
  LIVE_STREAM: 'liveStream',
  BANNED: 'banned',
  BLOCKED: 'blocked',
  NOTIFICATION: 'notification',
  HEART_MSG: 'heartMsg',
  LINK: 'link',
  SEND_AGAIN: 'send-again',
  OPEN_LINK: 'open-link',
  GIF: 'gif',
  PHOTO: 'photo',
  REACTIONS: 'reactions',
  QUOTE_MESSAGE: 'quote',
  FASTEN_DELETE: 'fastenDelete',
  TOOK_SCREEN_SHOT: 'screenshot',
  REMOVED_FROM_GROUP: 'removedFromGroup',
  INVITE_GROUP_CHAT: 'inviteGroupChat',
  LEAVE_GROUP_CHAT: 'leaveGroupChat',
  JOINED_GROUP_CHAT: 'joinGroupChat',
  SHARE_EVENT_TICKET: 'shareEventTicket',
  FASTEN_EDIT: 'fastenTxtEdit',
  INVITE_GROUP: 'inviteGroup',
} as const;

/**
 * Union type derived from the MESSAGE_TYPES values.
 * Provides full type safety across the application for message-related logic.
 */
export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];

// --- Legacy Exports for Backward Compatibility ---
// These ensure that existing files importing individual constants do not break.

export const TYPE_TEXT = MESSAGE_TYPES.TEXT;
export const TYPE_GIFT = MESSAGE_TYPES.GIFT;
export const TYPE_SHARE_LOCATION = MESSAGE_TYPES.SHARE_LOCATION;
export const TYPE_SHARE_EVENT = MESSAGE_TYPES.SHARE_EVENT;
export const TYPE_SHARE_DATE = MESSAGE_TYPES.SHARE_DATE;
export const TYPE_MEDIA = MESSAGE_TYPES.MEDIA;
export const TYPE_IMAGE = MESSAGE_TYPES.IMAGE;
export const TYPE_VIDEO_FILE = MESSAGE_TYPES.VIDEO_FILE;
export const TYPE_AUDIO_FILE = MESSAGE_TYPES.AUDIO_FILE;
export const TYPE_GALLERY = MESSAGE_TYPES.GALLERY;
export const TYPE_CHAT_STATE = MESSAGE_TYPES.CHAT_STATE;
export const TYPE_VIDEO = MESSAGE_TYPES.VIDEO;
export const TYPE_PRIVATE_MSG = MESSAGE_TYPES.PRIVATE_MSG;
export const TYPE_LIVE_STREAM = MESSAGE_TYPES.LIVE_STREAM;
export const TYPE_BANNED = MESSAGE_TYPES.BANNED;
export const TYPE_BLOCKED = MESSAGE_TYPES.BLOCKED;
export const TYPE_NOTIFICATION = MESSAGE_TYPES.NOTIFICATION;
export const TYPE_HEART_MSG = MESSAGE_TYPES.HEART_MSG;
export const TYPE_LINK = MESSAGE_TYPES.LINK;
export const SEND_AGAIN = MESSAGE_TYPES.SEND_AGAIN;
export const OPEN_LINK = MESSAGE_TYPES.OPEN_LINK;
export const TYPE_GIF = MESSAGE_TYPES.GIF;
export const TYPE_PHOTO = MESSAGE_TYPES.PHOTO;
export const TYPE_REACTIONS = MESSAGE_TYPES.REACTIONS;
export const TYPE_QUOTE_MESSAGE = MESSAGE_TYPES.QUOTE_MESSAGE;
export const TYPE_FASTEN_DELETE = MESSAGE_TYPES.FASTEN_DELETE;
export const TYPE_TOOK_SCREEN_SHOT = MESSAGE_TYPES.TOOK_SCREEN_SHOT;
export const REMOVED_FROM_GROUP = MESSAGE_TYPES.REMOVED_FROM_GROUP;
export const TYPE_REMOVED_FROM_GROUP = MESSAGE_TYPES.REMOVED_FROM_GROUP;
export const TYPE_INVITE_GROUP_CHAT = MESSAGE_TYPES.INVITE_GROUP_CHAT;
export const TYPE_LEAVE_GROUP_CHAT = MESSAGE_TYPES.LEAVE_GROUP_CHAT;
export const TYPE_JOINED_GROUP_CHAT = MESSAGE_TYPES.JOINED_GROUP_CHAT;
export const TYPE_SHARE_EVENT_TICKET = MESSAGE_TYPES.SHARE_EVENT_TICKET;
export const TYPE_FASTEN_EDIT = MESSAGE_TYPES.FASTEN_EDIT;
export const TYPE_INVITE_GROUP = MESSAGE_TYPES.INVITE_GROUP;
